export default __webpack_public_path__ + "static/media/480_business04-en-web.5ae2f427.png";